/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchAndSavePreviewImagesByWordRequest
 */
export interface SearchAndSavePreviewImagesByWordRequest {
    /**
     * Search term to find images for
     * @type {string}
     * @memberof SearchAndSavePreviewImagesByWordRequest
     */
    word: string;
    /**
     * Number of images to search and save (default: 5, max: 20)
     * @type {number}
     * @memberof SearchAndSavePreviewImagesByWordRequest
     */
    count?: number;
}

/**
 * Check if a given object implements the SearchAndSavePreviewImagesByWordRequest interface.
 */
export function instanceOfSearchAndSavePreviewImagesByWordRequest(value: object): value is SearchAndSavePreviewImagesByWordRequest {
    if (!('word' in value) || value['word'] === undefined) return false;
    return true;
}

export function SearchAndSavePreviewImagesByWordRequestFromJSON(json: any): SearchAndSavePreviewImagesByWordRequest {
    return SearchAndSavePreviewImagesByWordRequestFromJSONTyped(json, false);
}

export function SearchAndSavePreviewImagesByWordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAndSavePreviewImagesByWordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'word': json['word'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

  export function SearchAndSavePreviewImagesByWordRequestToJSON(json: any): SearchAndSavePreviewImagesByWordRequest {
      return SearchAndSavePreviewImagesByWordRequestToJSONTyped(json, false);
  }

  export function SearchAndSavePreviewImagesByWordRequestToJSONTyped(value?: SearchAndSavePreviewImagesByWordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'word': value['word'],
        'count': value['count'],
    };
}

